export const DELETE_CHART = 'events/DELETE_CHART';

/**
 * @param chart
 * @return {{type: string, payload: chart}
 */
export const deleteChart = (chart) => ({
  type: DELETE_CHART,
  payload: chart,
});
